<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-scale-balance"></i>
                <h2>Consulta histórico jurídico</h2>
              </div>
            </div>
          </div>

          <form @submit.prevent.stop="loadDemonstrativo">
            <div class="row">
              <div class="sm-12 md-3">
                <label>
                  De:
                  <input
                    v-model="data_de"
                    type="date"
                    lang="pt"
                    placeholder="De" />
                </label>
              </div>
              <div class="sm-12 md-3">
                <label>
                  Até:
                  <input
                    v-model="data_ate"
                    type="date"
                    lang="pt"
                    placeholder="Até" />
                </label>
              </div>
              <div class="sm-12 md-3">
                <label> Unidades: </label>
                <Multiselect
                  v-model="unidades_selecionadas"
                  :options="unidades"></Multiselect>
              </div>
              <div class="sm-12 md-3 checkbox">
                <label>
                  <input type="checkbox" v-model="mostrar_encerrados" />
                  Incluir MEMOS encerrados
                </label>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-6">
                <button
                  class="button secondary"
                  style="margin-top: 20px"
                  v-if="gerando"
                  disabled>
                  Gerando...
                </button>
                <button
                  type="submit"
                  class="button secondary"
                  style="margin-top: 20px"
                  v-else>
                  Gerar extrato
                </button>
              </div>
              <div class="sm-12 md-6 text-right">
                <button
                  class="button secondary visible-md"
                  style="margin-top: 20px"
                  @click.prevent.stop="print">
                  Imprimir
                </button>
              </div>
            </div>
          </form>

          <DadosCondominio
            :data_de="data_de"
            :data_ate="data_ate"
            v-if="itens"></DadosCondominio>
          <Unidade
            v-for="unidade in itens"
            :key="unidade.CodUnidade"
            :unidade="unidade"></Unidade>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from "luxon";
import api from "/plugins/api";
import Multiselect from "../../components/multiselect.vue";
import Swal from "sweetalert2";
import Unidade from "./historico-juridico/unidade.vue";
import DadosCondominio from "./historico-juridico/dados-condominio.vue";
export default {
  components: {
    Multiselect,
    Unidade,
    DadosCondominio,
  },
  data() {
    let hoje = DateTime.local();
    let last_day = hoje.daysInMonth;
    return {
      gerando: false,
      errors: [],
      unidades: [],
      unidades_selecionadas: [],
      mostrar_encerrados: false,
      itens: null,
      data_de: hoje.toFormat("yyyy-LL-01"),
      data_ate: hoje.toFormat(`yyyy-LL-${last_day}`),
    };
  },
  computed: {
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }

      return this.condominio.codigo;
    },
  },
  methods: {
    print() {
      window.print();
    },
    async loadUnidades() {
      try {
        if (!this.codigo_condominio) {
          return;
        }
        this.unidades = [];
        let { data: unidades } = await api.get(
          `condominios/${this.codigo_condominio}/historico-juridico/unidades`
        );
        this.unidades = unidades.map(
          ({ CodUnidade: value, Descricao: label }) => ({ value, label })
        );
      } catch (err) {
        console.error(err);
      }
    },
    async loadDemonstrativo() {
      try {
        if (this.gerando) {
          return;
        }
        if (!this.codigo_condominio) {
          return;
        }

        this.gerando = true;
        this.itens = null;
        this.errors = [];

        let params = {};

        if (this.unidades_selecionadas.length != 0) {
          params.unidades = this.unidades_selecionadas;
        }

        if (this.mostrar_encerrados) {
          params.mostrar_encerrados = this.mostrar_encerrados;
        }

        let { data: itens } = await api.get(
          `condominios/${this.codigo_condominio}/historico-juridico/${this.data_de}/${this.data_ate}`,
          {
            params,
          }
        );

        if (itens.length == 0) {
          Swal.fire({
            icon: "info",
            title: "Info",
            text: "Nenhum registro encontrado.",
          });
        }

        this.itens = itens;
      } catch (err) {
        let text = err.message || "Não foi possível carregar o demonstrativo.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        this.loadUnidades();
      },
    },
  },
};
</script>
<style lang="less" scoped>
div.checkbox {
  display: flex;
  align-items: center;
  label {
    display: flex;
    align-items: center;
    input {
      height: 1em;
      width: 1em;
    }
  }
}
</style>
